import React, { useState, useEffect, Fragment, useRef } from 'react';
import {
  Box, Card, CardContent, CardHeader, Container, makeStyles, Divider, InputLabel,
  MenuItem, TextField, Button, Table, TableHead, TableRow, TableCell, TableBody,
  TableContainer, Grid, TablePagination
} from '@material-ui/core';
import Page from 'src/components/Page';
import PerfectScrollbar from 'react-perfect-scrollbar';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { useAlert } from "react-alert";
import { Formik } from 'formik';
import * as Yup from "yup";
import tokenService from '../../../../utils/tokenDecoder';
import authService from '../../../../utils/permissionAuth';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import CreatePDF from './CreatePDF';
import moment from 'moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'COPMAPPINGDETAILS';

export default function COPMappingdetails() {
  const classes = useStyles();
  const [title] = useState("COP Mapping Detail Report");
  const [groups, setGroups] = useState([]);
  const [factories, setFactories] = useState([]);
  const [copTypes, setCopTypes] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [formState, setFormState] = useState({
    groupID: '0',
    factoryID: '0',
    accountDescriptionTypeID: '0',
    startDate: new Date().toISOString().substring(0, 10),
    endDate: new Date().toISOString().substring(0, 10)
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isBalanceRateChangeEnabled: false
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    accountDescriptionTypeName: '0',
    startDate: '',
    endDate: ''
  });
  const componentRef = useRef();
  const alert = useAlert();

  useEffect(() => {
    trackPromise(getPermissions());
    trackPromise(loadGroups());
  }, []);

  useEffect(() => {
    loadFactories();
  }, [formState.groupID]);

  useEffect(() => {
    trackPromise(loadCopTypes());
  }, [formState.factoryID]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode === 'VIEWCOPMAPPINGDETAILS');
    if (!isAuthorized) window.location.href = '/404';
    setPermissions({
      isGroupFilterEnabled: !!permissions.find(p => p.permissionCode === 'GROUPDROPDOWN'),
      isFactoryFilterEnabled: !!permissions.find(p => p.permissionCode === 'FACTORYDROPDOWN'),
      isBalanceRateChangeEnabled: false
    });
    setFormState(prev => ({
      ...prev,
      groupID: parseInt(tokenService.getGroupIDFromToken()).toString(),
      factoryID: parseInt(tokenService.getFactoryIDFromToken()).toString()
    }));
  }

  async function loadGroups() {
    const result = await services.getAllGroups();
    setGroups(result);
  }
  async function loadFactories() {
    const result = await services.getAllFactoriesByGroupID(formState.groupID);
    setFactories(result);
  }
  async function loadCopTypes() {
    const result = await services.GetCopTypeByGroupIDAndFactory(formState.factoryID);
    setCopTypes(result);
  }

  async function handleSearch() {
    let model = {
      groupID: parseInt(formState.groupID),
      factoryID: parseInt(formState.factoryID),
      accountDescriptionTypeID: parseInt(formState.accountDescriptionTypeID),
      startDate: moment(formState.startDate).format('YYYY-MM-DD'),
      endDate: moment(formState.endDate).format('YYYY-MM-DD')
    };
    let response = await services.GetCopMappingDetails(model);
    if (response && response.statusCode === "Success" && Array.isArray(response.data) && response.data.length > 0) {
      setTableData(response.data);
      setSelectedSearchValues({
        groupName: groups[formState.groupID],
        factoryName: factories[formState.factoryID],
        accountDescriptionTypeName: copTypes[formState.accountDescriptionTypeID],
        startDate: formState.startDate,
        endDate: formState.endDate
      });
      setPage(0);
    } else {
      setTableData([]);
      alert.error("No records to display.");
      setPage(0);
    }
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data) {
      Object.entries(data).forEach(([key, value]) => {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      });
    }
    return items;
  }

  function handleChange(e) {
    const { name, value } = e.target;
    if (name == 'groupID') {
      setFormState({
        ...formState,
        groupID: value,
        factoryID: 0,
        accountDescriptionTypeID: 0
      });
    } else if (name == 'factoryID') {
      setFormState({
        ...formState,
        factoryID: value,
        accountDescriptionTypeID: 0
      })
    } else {
      setFormState(prev => ({ ...prev, [name]: value }));
    }
    setTableData([]);
    setPage(0);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>{titleName}</Grid>
      </Grid>
    );
  }

  async function createDataForExcel(array) {
    let res = [];
    if (Array.isArray(array)) {
      array.forEach(x => {
        res.push({
          'Voucher Number': x.vno,
          'Date': x.date ? x.date.substring(0, 10) : "",
          'Account': x.account,
          'Description': x.description,
          'Credit': x.credit,
          'Debit': x.debit
        });
      });
    }
    res.push({});
    var vr = {
      'Voucher Number': 'Total:',
      'Credit': Number(array.reduce((sum, x)=>((sum + x.credit)), 0)),
      'Debit': Number(array.reduce((sum, x)=>((sum + x.debit)), 0))
    }
    res.push(vr);
    res.push({});
    var vr = {
      'Voucher Number': 'Group: ' + selectedSearchValues.groupName,
      'Date': 'Factory: ' + selectedSearchValues.factoryName
    }
    res.push(vr);
    var vr = {
      'Voucher Number': 'COP Type: ' + selectedSearchValues.accountDescriptionTypeName,
    }
    res.push(vr);
    var vr = {
      'Voucher Number': 'From: ' + selectedSearchValues.startDate,
      'Date': 'To: ' + selectedSearchValues.endDate
    }
    res.push(vr);
    return res;
  }

  async function createFile() {
    const file = await createDataForExcel(tableData);
    const settings = {
      sheetName: 'COP Mapping Report',
      fileName:
        'COP Mapping Details Report - ' + selectedSearchValues.groupName +
        ' - ' + selectedSearchValues.factoryName +
        ' - ' + selectedSearchValues.startDate +
        ' - ' + selectedSearchValues.endDate,
      writeOptions: {}
    };
    const keys = file.length > 0 ? Object.keys(file[0]) : [];
    let tempcsvHeaders = [];
    keys.forEach(sitem => {
      tempcsvHeaders.push({ label: sitem, value: sitem });
    });
    SetCsvHeaders(tempcsvHeaders);
    const dataA = [{
      sheet: 'COP Mapping Report',
      columns: tempcsvHeaders,
      content: file
    }];
    xlsx(dataA, settings);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getPageMargins = () => {
    return `@media print {
            @page {
            background-color: white !important;
        }
        body {
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: formState.groupID,
              factoryID: formState.factoryID,
              accountDescriptionTypeID: formState.accountDescriptionTypeID,
              startDate: formState.startDate,
              endDate: formState.endDate
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
              factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
              accountDescriptionTypeID: Yup.number().required('COP Type is required').min("1", 'COP Type is required'),
              startDate: Yup.date().required('From Date is Required'),
              endDate: Yup.date().required('To Date is Required'),
            })}
            onSubmit={() => trackPromise(handleSearch())}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={8}>
                            <InputLabel shrink id="groupID">Group *</InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={formState.groupID}
                              variant="outlined"
                              id="groupID"
                              size='small'
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={8}>
                            <InputLabel shrink id="factoryID">Factory *</InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={formState.factoryID}
                              variant="outlined"
                              id="factoryID"
                              size='small'
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={8}>
                            <InputLabel shrink id="accountDescriptionTypeID">COP Type *</InputLabel>
                            <TextField select
                              fullWidth
                              error={Boolean(touched.accountDescriptionTypeID && errors.accountDescriptionTypeID)}
                              helperText={touched.accountDescriptionTypeID && errors.accountDescriptionTypeID}
                              name="accountDescriptionTypeID"
                              onChange={handleChange}
                              value={formState.accountDescriptionTypeID}
                              variant="outlined"
                              id="accountDescriptionTypeID"
                              onBlur={handleBlur}
                              size="small"
                            >
                              <MenuItem value="0">--Select COP Item--</MenuItem>
                              {generateDropDownMenu(copTypes)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>From Date *</InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                name='startDate'
                                id='startDate'
                                value={startDate}
                                maxDate={new Date()}
                                onChange={(date) => {
                                  setStartDate(date);
                                  setFormState(prev => ({
                                    ...prev,
                                    startDate: date ? moment(date).format('YYYY-MM-DD') : ''
                                  }));
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                autoOk
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>To Date *</InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                name='endDate'
                                id='endDate'
                                value={endDate}
                                minDate={startDate}
                                maxDate={new Date()}
                                onChange={(date) => {
                                  setEndDate(date);
                                  setFormState(prev => ({
                                    ...prev,
                                    endDate: date ? moment(date).format('YYYY-MM-DD') : ''
                                  }));
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                autoOk
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size='small'
                          >
                            Search
                          </Button>
                        </Box>
                        <br />
                        <Box minWidth={1050}>
                          {tableData.length > 0 ? (
                            <Box>
                              <TableContainer>
                                <Table aria-label="caption table" size='small'>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell align="center" style={{ border: '1px solid black' }}>VNO</TableCell>
                                      <TableCell align="center" style={{ border: '1px solid black' }}>Date</TableCell>
                                      <TableCell align="center" style={{ border: '1px solid black' }}>Account</TableCell>
                                      <TableCell align="center" style={{ border: '1px solid black' }}>Description</TableCell>
                                      <TableCell align="center" style={{ border: '1px solid black' }}>Credit</TableCell>
                                      <TableCell align="center" style={{ border: '1px solid black' }}>Debit</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data, index) => (
                                      <TableRow key={index}>
                                        <TableCell align="left" style={{ border: '1px solid black' }}>{data.vno}</TableCell>
                                        <TableCell align="center" style={{ border: '1px solid black' }}>{data.date ? data.date.substring(0, 10) : ""}</TableCell>
                                        <TableCell align="left" style={{ border: '1px solid black' }}>{data.account}</TableCell>
                                        <TableCell align="left" style={{ border: '1px solid black' }}>{data.description}</TableCell>
                                        <TableCell align="right" style={{ border: '1px solid black' }}>{Number(data.credit || 0).toFixed(2)}</TableCell>
                                        <TableCell align="right" style={{ border: '1px solid black' }}>{Number(data.debit  || 0).toFixed(2)}</TableCell>
                                      </TableRow>
                                    ))}
                                    <TableRow>
                                      <TableCell colSpan={4} align="left" style={{ border: '1px solid black' }}>Total</TableCell>
                                      <TableCell align="right" style={{ border: '1px solid black' }}>{tableData.reduce((sum, data) => (sum + Number(data.credit || 0)), 0).toFixed(2)}</TableCell>
                                      <TableCell align="right" style={{ border: '1px solid black' }}>{tableData.reduce((sum, data) => (sum + Number(data.debit || 0)), 0).toFixed(2)}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                                <TablePagination
                                  rowsPerPageOptions={[5, 10, 20]}
                                  component="div"
                                  count={tableData.length}
                                  rowsPerPage={rowsPerPage}
                                  page={page}
                                  onChangePage={handleChangePage}
                                  onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                              </TableContainer>
                              <Box display="flex" justifyContent="flex-end" p={2}>
                                <Button
                                  color="primary"
                                  id="btnRecord"
                                  type="button"
                                  variant="contained"
                                  style={{ marginRight: '1rem' }}
                                  className={classes.colorRecord}
                                  onClick={createFile}
                                  size="small"
                                >
                                  EXCEL
                                </Button>
                                <ReactToPrint
                                  documentTitle={'COP Mapping Details Report - ' + selectedSearchValues.groupName +
                                      ' - ' + selectedSearchValues.factoryName +
                                      ' - ' + selectedSearchValues.startDate +
                                      ' - ' + selectedSearchValues.endDate}
                                  trigger={() => (
                                    <Button
                                      color="primary"
                                      id="btnCancel"
                                      variant="contained"
                                      style={{ marginRight: '1rem' }}
                                      className={classes.colorCancel}
                                      size="small"
                                    >
                                      PDF
                                    </Button>
                                  )}
                                  pageStyle={getPageMargins()}
                                  content={() => componentRef.current}
                                />
                                <div hidden={true}>
                                  <CreatePDF
                                    ref={componentRef}
                                    SlabReportSearchData={selectedSearchValues}
                                    CropSlabData={tableData}
                                  />
                                </div>
                              </Box>
                            </Box>
                          ) : null}
                        </Box>
                      </CardContent>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
